<template>
  <div class="form-option-card-element-wrapper" :class="getOptionClass">
    <FormLabel
      :element="element"
      :labelStyle="labelStyle"
      :fieldStyle="fieldStyle"
    />
    <FormDescription :element="element" :labelStyle="labelStyle" />

    <b-row class="card-columns m-0">
      <div
        v-for="(option, index) in getCardOptions"
        :key="index"
        class="card-box bg-transparent p-0 m-0 position-relative"
        :style="getCardBoxStyle"
      >
        <b-card
          @click="onClickOptionCard(option)"
          class="overflow-hidden border-0 w-100 position-relative bg-transparent card-option-box"
          :class="[
            `card-option-${index}-box-${element.id}`,
            { active: option.checked, 'disabled-overlay': isDisabled },
            getCardModeClass(option),
          ]"
          :style="getCardSizeStyle"
          :id="`card-option-${index}-box-${element.id}`"
        >
          <div
            v-if="option.showImageInsideCard"
            class="card-img-wrapper overflow-hidden"
            :style="getImageSizeStyle"
          >
            <b-card-img
              class="h-100 object-fit-contain w-100"
              :class="[`card-option-${index}-img-${element.id}`]"
              v-if="option.img"
              :src="option.img"
              :id="`card-option-${index}-img-${element.id}`"
            />
          </div>
          <div
            v-else-if="option.img"
            class="card-bg position-absolute top-0 start-0 w-100 h-100"
            :style="{
              backgroundImage: `url(${option.img})`,
            }"
          ></div>
          <div
            v-if="
              !element.settings.isTextOutSide &&
              isShowCardField('cardContent', option)
            "
            class="card-content w-100 position-relative d-flex flex-column bg-transparent"
            :class="[`card-option-${index}-content-${element.id}`]"
            :id="`card-option-${index}-content-${element.id}`"
          >
            <b-card-title
              class="h-100 fs-6 d-flex align-items-center justify-content-center flex-column text-break fw-bold"
              :style="labelStyle"
              v-if="isShowCardField('title', option)"
            >
              <span
                :id="`card-option-${index}-label-${element.id}`"
                :class="[`card-option-${index}-label-${element.id}`]"
                v-if="option?.label?.length"
              >
                {{ option.label }}
              </span>
              <p
                v-if="isShowCardField('modalLink', option)"
                @click.stop="onClickModalLink(option)"
                class="fw-normal modal-link-text"
                :style="labelStyle"
                :class="[`card-option-${index}-modal-link-${element.id}`]"
                :id="`card-option-${index}-modal-link-${element.id}`"
              >
                {{ option.modalConfig.modalLink }}
              </p></b-card-title
            >
            <b-card-text
              v-if="isShowCardField('description', option)"
              class="text-break card-description fw-normal m-0"
              :style="labelStyle"
              :class="[`card-option-${index}-desciption-${element.id}`]"
              :id="`card-option-${index}-description-${element.id}`"
            >
              {{ option.description }}
            </b-card-text>
            <b-card-text
              v-if="isShowCardField('link', option)"
              class="text-break fw-normal w-100 option-link-text"
              :class="[
                element.options?.[0]?.linkDetails?.position,
                `card-option-${index}-link-${element.id}`,
              ]"
              :id="`card-option-${index}-link-${element.id}`"
              :style="labelStyle"
              @click.stop="onClickLink(option)"
            >
              {{ option.linkDetails.label }}
            </b-card-text>
          </div>
        </b-card>
        <div
          v-if="
            element.settings.isTextOutSide &&
            isShowCardField('cardContent', option)
          "
          :class="{ 'disabled-overlay': isDisabled }"
          class="outer-content card-content w-100 position-relative d-flex flex-column bg-transparent"
        >
          <b-card-title
            class="h-100 fs-6 d-flex align-items-center justify-content-center flex-column text-break fw-bold"
            :style="labelStyle"
            v-if="isShowCardField('title', option)"
          >
            <span
              v-if="option?.label?.length"
              :class="[`card-option-${index}-label-${element.id}`]"
              :id="`card-option-${index}-label-${element.id}`"
            >
              {{ option.label }}
            </span>
            <p
              v-if="isShowCardField('modalLink', option)"
              @click.stop="onClickModalLink(option)"
              class="fw-normal modal-link-text"
              :class="[`card-option-${index}-modal-link-${element.id}`]"
              :id="`card-option-${index}-modal-link-${element.id}`"
              :style="labelStyle"
            >
              {{ option.modalConfig.modalLink }}
            </p>
          </b-card-title>
          <b-card-text
            v-if="isShowCardField('description', option)"
            class="text-break card-description fw-normal m-0"
            :class="[`card-option-${index}-description-${element.id}`]"
            :id="`card-option-${index}-description-${element.id}`"
            :style="labelStyle"
          >
            {{ option.description }}
          </b-card-text>
          <b-card-text
            v-if="isShowCardField('link', option)"
            class="text-break fw-normal w-100 option-link-text"
            :style="labelStyle"
            :class="[
              element.options?.[0]?.linkDetails?.position,
              `card-option-${index}-link-${element.id}`,
            ]"
            :id="`card-option-${index}-link-${element.id}`"
            @click.stop="onClickLink(option)"
          >
            {{ option.linkDetails.label }}
          </b-card-text>
        </div>
      </div>
    </b-row>
  </div>
</template>

<script>
import { DEFAULT_FORM_STYLES } from '@/utils/constants/WorkFlowConstants';
import { hexToRgba, isHexTooLight, isImageDark } from '@/utils/helpers';
import FormLabel from '@/components/FormBuilder/core/FormLabel.vue';
import FormDescription from '@/components/FormBuilder/core/FormDescription.vue';
export default {
  name: 'FormOptionCardElement',
  data() {
    return {
      imageInfoList: [],
    };
  },
  props: {
    element: {
      type: Object,
      required: true,
    },
    labelStyle: { type: Object, default: () => {} },
    fieldStyle: { type: Object, default: () => {} },
    brandedStyle: { type: Object, default: () => {} },
    isPreview: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  methods: {
    onClickOptionCard(option) {
      if (this.isDisabled || !this.isPreview) return;
      const selectedOption = this.element.options.find(
        (op) => op.value === option.value
      );

      if (this.element.type === 'radio') {
        this.element.options.forEach((option) => {
          option.checked = option.value === selectedOption.value;
        });
        this.element.value = selectedOption.value;
      } else if (this.element.type === 'checkbox') {
        selectedOption.checked = !selectedOption.checked;
        if (selectedOption.checked)
          this.element.value.push(selectedOption.value);
        else
          this.element.value = this.element.value.filter(
            (e) => e !== selectedOption.value
          );
      }
    },
    async setIsImageDark() {
      try {
        if (
          !this.element.settings.isImgShowInBackGround ||
          (this.brandedStyle && this.brandedStyle.hasOwnProperty('textColor'))
        )
          return;
        for (const option of this.element.options) {
          if (!option.img) {
            continue;
          }
          const isExist = this.imageInfoList.find(
            (img) => img.imageUrl === option.img
          );
          if (!isExist) {
            const isDark = await this.isImageDark(option.img);
            this.imageInfoList.push({ imageUrl: option.img, isDark });
          }
        }
      } catch (error) {
        console.log('error', error);
      }
    },
    async isImageDark(imgURL) {
      try {
        const isDark = await isImageDark(imgURL);
        return isDark;
      } catch (error) {
        return false;
      }
    },
    getCardModeClass(option) {
      if (
        (this.brandedStyle && this.brandedStyle.hasOwnProperty('textColor')) ||
        !this.element.settings.isImgShowInBackGround
      )
        return '';
      const imageinfo = this.imageInfoList.find(
        (img) => img.imageUrl === option.img
      );
      if (imageinfo) return imageinfo.isDark ? 'dark-mode' : 'light-mode';
      return '';
    },
    onClickModalLink(option) {
      if (!option.isModalVisible || !option.modalConfig) return;
      this.$emit('onOpenCardModal', option);
    },
    isShowCardContent(option) {
      return (
        option?.label?.length ||
        (option.isModalVisible && option?.modalConfig?.modalLink) ||
        option?.showDescription
      );
    },
    onClickLink(option) {
      if (option?.linkDetails?.link)
        window.open(option.linkDetails.link, '_blank');
    },
    isShowCardField(fieldName, option) {
      const isModalLinkShow =
        !!option.isModalVisible && !!option?.modalConfig?.modalLink?.length;
      const isTitleShow = !!option?.label?.length || isModalLinkShow;
      const isDescriptionShow =
        option.showDescription && !!option?.description?.length;
      const isLinkShow =
        !!this.element.settings?.isOptionLinked &&
        !!option?.linkDetails?.label?.length;
      if (fieldName === 'title') return isTitleShow;
      else if (fieldName === 'modalLink') return isModalLinkShow;
      else if (fieldName === 'description') return isDescriptionShow;
      else if (fieldName === 'link') return isLinkShow;
      else if (fieldName === 'cardContent')
        return (
          isTitleShow || isModalLinkShow || isDescriptionShow || isLinkShow
        );
      else true;
    },
  },
  watch: {
    element: {
      handler() {
        this.setIsImageDark();
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    getCardOptions() {
      return this.element.options.map((option) => {
        return {
          ...option,
          showImageInsideCard:
            !this.element.settings.isImgShowInBackGround && option.img,
          showDescription: this.element.settings.isShowTitleAndDescription,
        };
      });
    },
    getCardStyle() {
      return {
        selectedBorderColor:
          this.brandedStyle?.primaryBrandColor ||
          DEFAULT_FORM_STYLES.selectedBorderColor,
        borderRadius:
          this.brandedStyle &&
          this.brandedStyle.hasOwnProperty('primaryBordarRadius')
            ? `${this.brandedStyle?.primaryBordarRadius}px`
            : `${DEFAULT_FORM_STYLES.borderRadius}px`,
        imageBorderRadius:
          this.brandedStyle &&
          this.brandedStyle.hasOwnProperty('primaryBordarRadius')
            ? `${this.brandedStyle?.primaryBordarRadius * 0.6}px`
            : `${DEFAULT_FORM_STYLES.borderRadius * 0.6}px`,

        selectOverlayColor: isHexTooLight(
          this.brandedStyle?.textColor || DEFAULT_FORM_STYLES.inputColor
        )
          ? hexToRgba('#000000', 0.8)
          : hexToRgba('#ffffff', 0.8),
      };
    },
    isDisabled() {
      return this.disabled || this.element.settings.disabled;
    },
    getOptionClass() {
      return `${this.element.settings.sizeSettingValue}-option ${
        this.element.settings.isImageAdjust
          ? `img-position-${this.element.settings.imagePosition}`
          : ''
      }`;
    },
    getCardBoxStyle() {
      return this.element.settings.sizeSettingValue === 'individuel'
        ? {
            minHeight:
              Math.max(this.element.settings.customSize.height, 25) + 'px',
            width: Math.max(this.element.settings.customSize.width, 25) + 'px',
          }
        : this.element.settings.sizeSettingValue === 'small'
        ? this.element.settings.isTextOutSide
          ? {
              width: 76 + 'px',
              minHeight: 76 + 'px',
            }
          : { minWidth: 76 + 'px', minHeight: 76 + 'px', width: 'auto' }
        : this.element.settings.sizeSettingValue === 'medium'
        ? { width: 150 + 'px', minHeight: 150 + 'px' }
        : this.element.settings.isTextOutSide
        ? {
            width: 218 + 'px',
            minHeight: 181 + 'px',
            minWidth: 218 + 'px',
          }
        : { maxWidth: 218 + 'px', minHeight: 181 + 'px' };
    },
    getCardSizeStyle() {
      return this.element.settings.sizeSettingValue === 'individuel'
        ? this.element.settings.isTextOutSide
          ? {
              height:
                Math.max(this.element.settings.customSize.height, 25) + 'px',
            }
          : {
              minHeight:
                Math.max(this.element.settings.customSize.height, 25) + 'px',
            }
        : this.element.settings.sizeSettingValue === 'small'
        ? this.element.settings.isTextOutSide
          ? {
              width: 76 + 'px',
              height: 76 + 'px',
            }
          : { minWidth: 76 + 'px', minHeight: 76 + 'px', width: 'auto' }
        : this.element.settings.sizeSettingValue === 'medium'
        ? this.element.settings.isTextOutSide
          ? {
              width: 150 + 'px',
              height: 150 + 'px',
            }
          : { width: 150 + 'px', minHeight: 150 + 'px' }
        : this.element.settings.isTextOutSide
        ? {
            width: 218 + 'px',
            minHeight: 181 + 'px',
            height: 181 + 'px',
            minWidth: 218 + 'px',
          }
        : { maxWidth: 218 + 'px', minHeight: 181 + 'px' };
    },
    getImageSizeStyle() {
      const width = this.element.settings.customSize.width;
      const height = this.element.settings.customSize.height;
      return this.element.settings.sizeSettingValue === 'individuel' &&
        !this.element.settings.isTextOutSide
        ? ['left', 'right'].includes(this.element.settings.imagePosition)
          ? {
              height: Math.max(height - 20, 25) + 'px',
              width: Math.max(width / 4, 25) + 'px',
            }
          : this.element.settings.imagePosition === 'center'
          ? {
              height: Math.max(height / 2, 25) + 'px',
              width: '100%',
              minWidth: Math.max(width / 4, 25) + 'px',
            }
          : {}
        : {};
    },
  },
  components: {
    FormLabel,
    FormDescription,
  },
};
</script>

<style scoped>
.form-option-card-element-wrapper .card-columns {
  gap: 14px;
}
.form-option-card-element-wrapper .card-columns .card {
  display: flex;
}

.form-option-card-element-wrapper .card-box {
  border-radius: v-bind('getCardStyle.borderRadius');
  cursor: pointer;
  display: inline-flex;
}

.form-option-card-element-wrapper .card {
  outline: 0.7px solid #dddddd;
  outline-offset: -0.7px;
  border-radius: v-bind('getCardStyle.borderRadius');
}
.preview-mode
  .form-option-card-element-wrapper
  .card-box:has(.disabled-overlay) {
  cursor: not-allowed;
}

.form-option-card-element-wrapper .card-box .disabled-overlay:before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 4;
  border-radius: v-bind('getCardStyle.borderRadius');
}
.form-option-card-element-wrapper
  .card-box
  .outer-content.disabled-overlay:before {
  border-radius: 0 !important;
  top: 10px;
}

.preview-mode
  .form-option-card-element-wrapper:not(:has(.disabled-overlay))
  .card:not(:has(.card-bg)):hover,
.form-option-card-element-wrapper .card.active:not(:has(.card-bg)) {
  outline: 2.2px solid #000000;
  outline-color: v-bind('getCardStyle.selectedBorderColor');
  outline-offset: -2.2px;
}

.form-option-card-element-wrapper .card.active:not(:has(.card-bg)) {
  background-color: #f7f7f7;
}

.form-option-card-element-wrapper .card.active .card-body:has(.card-bg):before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: v-bind('getCardStyle.selectOverlayColor');
  z-index: 2;
}
.form-option-card-element-wrapper .card.dark-mode .card-body:before {
  background-color: #000000b2 !important;
}
.form-option-card-element-wrapper .card.light-mode .card-body:before {
  background-color: #ffffffb2 !important;
}

.form-option-card-element-wrapper .card .card-body {
  padding: 10px;
}
.form-option-card-element-wrapper .card:has(.card-img-wrapper) .card-body {
  padding: 15px;
}
.form-option-card-element-wrapper .card .card-body:has(.card-text) {
  padding: 17px 24px 24px 24px;
  flex: unset;
}

.form-option-card-element-wrapper
  .card:has(.card-text):has(.card-title)
  .card-img-wrapper {
  margin: 0 0 16px;
}
.form-option-card-element-wrapper .card .card-img-wrapper {
  height: 131px;
  border-radius: v-bind('getCardStyle.imageBorderRadius');
}
.form-option-card-element-wrapper .card:has(.card-content) .card-img-wrapper {
  margin: 0 0 22px;
}
.form-option-card-element-wrapper .card-img {
  object-position: center;
  transition: transform 0.5s ease;
}
.form-option-card-element-wrapper .card:hover .card-bg {
  transform: scale(1.15);
}

.form-option-card-element-wrapper .card-bg {
  background-size: cover;
  background-position: center;
  z-index: 1;
  transition-duration: 200ms;
  transition-timing-function: cubic-bezier(0.2, 0, 0, 1);
}

.form-option-card-element-wrapper .card .card-content {
  z-index: 2;
  height: 100%;
  align-items: center;
  justify-content: center;
  padding: 0;
}
.form-option-card-element-wrapper .card:has(.card-img-wrapper) .card-content {
  height: fit-content;
}

.form-option-card-element-wrapper .card .card-content:has(.card-description) {
  align-items: start;
  justify-content: flex-start;
}

.form-option-card-element-wrapper .card-content .card-title {
  font-family: 'OpenSans-Bold', 'Open Sans', open-sans;
  letter-spacing: -0.02em;
  line-height: 27px;
  margin: 0;
  color: #222222;
  cursor: auto;
}
.form-option-card-element-wrapper .card-box .card-content .modal-link-text {
  color: #5f697a;
  font-family: 'OpenSans-Regular';
  line-height: 27px;
  letter-spacing: -0.02em;
  font-size: 14px;
  text-decoration: underline;
  text-align: center;
  padding: 0;
  margin: 0;
  overflow: hidden;
  cursor: pointer;
}
.form-option-card-element-wrapper
  .card-box
  .card-content:has(.card-text)
  .modal-link-text {
  text-align: left;
}

.form-option-card-element-wrapper .card:has(.card-img-wrapper) .card-title {
  margin-bottom: 21px;
}
.form-option-card-element-wrapper .card-box:has(.card-text) .card-title {
  margin-bottom: 7px;
  align-items: start !important;
}

.form-option-card-element-wrapper
  .card-box
  .card-content
  .card-text
  .option-link-text,
.form-option-card-element-wrapper .card-box .card-content .card-text {
  font-family: 'OpenSans-Regular', 'Open Sans';
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.02em;
  color: #919191;
  cursor: auto;
}
.form-option-card-element-wrapper .card-box .option-link-text {
  display: block;
  text-decoration: underline;
  cursor: pointer !important;
  text-align: left;
}
.form-option-card-element-wrapper .card-box .option-link-text.right {
  text-align: right;
}
.form-option-card-element-wrapper .card-box .option-link-text.center {
  text-align: center;
}

.form-option-card-element-wrapper .card.dark-mode .card-title,
.form-option-card-element-wrapper .card.dark-mode .card-text {
  color: #ffffff !important;
}
.form-option-card-element-wrapper .card.light-mode .card-title,
.form-option-card-element-wrapper .card.light-mode .card-text {
  color: #000000 !important;
}

/* outside content style overwrite */
.form-option-card-element-wrapper .card-content.outer-content {
  padding-top: 10px;
}
.form-option-card-element-wrapper
  .card-content.outer-content:not(:has(.card-text))
  .card-title {
  text-align: center;
}
.form-option-card-element-wrapper .card-box:has(.outer-content) {
  flex-flow: column;
}

.form-option-card-element-wrapper .card-box:has(.outer-content) .card-body {
  width: 100%;
  height: 100%;
}
.form-option-card-element-wrapper
  .card-box:has(.outer-content)
  .card-img-wrapper {
  height: 100%;
  width: 100%;
}

/* small option style  */
.form-option-card-element-wrapper.small-option .card-columns {
  align-items: flex-start;
}

.form-option-card-element-wrapper.small-option .card .card-title {
  margin: 0 !important;
}

.form-option-card-element-wrapper.small-option .card-body {
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  padding: 0 !important;
}
.form-option-card-element-wrapper.small-option
  .card:not(:has(.card-img-wrapper))
  .card-content {
  padding: 20px 17px;
}

.form-option-card-element-wrapper.small-option .card .card-img-wrapper {
  margin: 0 !important;
  height: 50px;
  width: 50px;
  min-height: 50px;
  min-width: 50px;
}
.form-option-card-element-wrapper.small-option
  .card:has(.card-img-wrapper):has(:not(.card-title))
  .card-body {
  padding: 8px !important;
}

.form-option-card-element-wrapper.individuel-option .card,
.form-option-card-element-wrapper.small-option .card {
  justify-content: center;
}
/* small option style end */

/* medium option style start */
.form-option-card-element-wrapper.medium-option .card .card-img-wrapper {
  height: 120px;
}
/* medium option style end */

/* individuel option style  */
.form-option-card-element-wrapper.individuel-option .card-columns {
  align-items: flex-start;
}
.form-option-card-element-wrapper.individuel-option .card-box {
  width: auto;
  max-width: 100%;
}
.form-option-card-element-wrapper.individuel-option .card-content .card-title {
  margin: 0;
}

.form-option-card-element-wrapper.individuel-option .card-body {
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  padding: 10px !important;
}

.form-option-card-element-wrapper.individuel-option .card .card-img-wrapper {
  margin: 0 !important;
}
/* individuel option style end  */

/* image position style */
.form-option-card-element-wrapper.img-position-right
  .card-box:not(:has(.outer-content))
  .card-title,
.form-option-card-element-wrapper.img-position-left
  .card-box:not(:has(.outer-content))
  .card-title {
  margin: 0;
}
.form-option-card-element-wrapper.img-position-right
  .card-box:not(:has(.outer-content))
  .card-body,
.form-option-card-element-wrapper.img-position-left
  .card-box:not(:has(.outer-content))
  .card-body {
  height: 100%;
  display: flex;
  align-items: center;
  padding: 10px;
}
.form-option-card-element-wrapper.img-position-right.medium-option
  .card-box:not(:has(.outer-content))
  .card-img-wrapper,
.form-option-card-element-wrapper.img-position-left.medium-option
  .card-box:not(:has(.outer-content))
  .card-img-wrapper {
  height: 50px;
  min-width: 50px;
  width: 50px;
  margin: 0px;
}
.form-option-card-element-wrapper.img-position-right.large-option
  .card-box:not(:has(.outer-content))
  .card-img-wrapper,
.form-option-card-element-wrapper.img-position-left.large-option
  .card-box:not(:has(.outer-content))
  .card-img-wrapper {
  width: 60px;
  min-width: 60px;
  margin: 0px;
}

.form-option-card-element-wrapper.img-position-left
  .card-body:has(.card-img-wrapper) {
  flex-flow: row;
  gap: 21px;
  justify-content: center;
}

.form-option-card-element-wrapper.img-position-right
  .card-body:has(.card-img-wrapper) {
  flex-flow: row-reverse;
  gap: 21px;
  justify-content: center;
}
.form-option-card-element-wrapper.img-position-right
  .card:has(.card-img-wrapper)
  .card-content,
.form-option-card-element-wrapper.img-position-left
  .card:has(.card-img-wrapper)
  .card-content {
  align-items: flex-start;
}

@media (max-width: 767px) {
  form .custom .form-option-card-element-wrapper .card-box {
    max-width: 100%;
  }
}

@media (max-width: 457px) {
  form .no-margin .form-option-card-element-wrapper .card-box {
    max-width: 100%;
  }
}

@media (max-width: 537px) {
  form .large-margin .form-option-card-element-wrapper .card-box,
  form .standard-margin .form-option-card-element-wrapper .card-box {
    max-width: 100%;
  }

  form .large-margin .form-option-card-element-wrapper.large-option .card-box,
  form .standard-margin .form-option-card-element-wrapper.large-option .card-box {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
  }

  form
    .large-margin
    .form-option-card-element-wrapper.large-option
    .card-option-box,
  form
    .standard-margin
    .form-option-card-element-wrapper.large-option
    .card-option-box {
    width: 100% !important;
    max-width: 100% !important;
  }
}
</style>
